export const environment = {
  production: true,
  apiUri: 'https://hashtagbime.com/api/application/',
  clientKey: '25ac55ae11e9b73e9dce6b2fa1e18a8b',
  token: 'SAMANIUM'
};
